var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "34px",
    viewBox: "0 0 30 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "744D7EE5-55D1-456D-9B44-445E8158D444") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-MVP/12",
    transform: "translate(-563.000000, -537.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(563.000000, 537.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.67788224,
    cy: 5.42553191,
    r: 4.42553191
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.67788224,
    y1: 11.212766,
    x2: 5.67788224,
    y2: 15.5531915,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67814728,16.6297995 C7.247219,19.6940786 10.3557645,26.051379 10.3557645,28.3221178 C10.3557645,29.6138793 9.83217467,30.7833498 8.98564449,31.62988 C8.13911431,32.4764102 6.96964375,33 5.67788224,33 C4.38612073,33 3.21665017,32.4764102 2.37011999,31.62988 C1.5235898,30.7833498 1,29.6138793 1,28.3221178 C1,26.3580753 3.32554443,21.3368213 4.9691348,18.0339467 L5.26858209,17.4359609 C5.41357566,17.1482025 5.55092342,16.8781704 5.67814728,16.6297995 Z",
    id: "Oval-Copy"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(18.085106, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.67788224,
    cy: 5.42553191,
    r: 4.42553191
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.67788224,
    y1: 11.212766,
    x2: 5.67788224,
    y2: 15.5531915,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67814728,16.6297995 C7.247219,19.6940786 10.3557645,26.051379 10.3557645,28.3221178 C10.3557645,29.6138793 9.83217467,30.7833498 8.98564449,31.62988 C8.13911431,32.4764102 6.96964375,33 5.67788224,33 C4.38612073,33 3.21665017,32.4764102 2.37011999,31.62988 C1.5235898,30.7833498 1,29.6138793 1,28.3221178 C1,26.3580753 3.32554443,21.3368213 4.9691348,18.0339467 L5.26858209,17.4359609 C5.41357566,17.1482025 5.55092342,16.8781704 5.67814728,16.6297995 Z",
    id: "Oval-Copy"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/Group2.6d11699312c1d8ef114d3f4a39ec6b41.svg";
export { ForwardRef as ReactComponent };